<template src="./App.html"></template>
<style lang="scss" src="../assets/scss/_customs.scss"></style>

<script>
import BaseApp from '@/BaseApp'
import Cookie from 'js-cookie'
import { initGTM } from '@/helper'
import { mapState } from 'vuex'
import AppFooter from '@/components/layout/AppFooter'
import CookieOverlay from '@/components/overlays/CookieOverlay'
import NewsLetterSubscriptionOverlay from '@/components/overlays/NewsLetterSubscriptionOverlay'

export default {
  components: {
    AppFooter,
    CookieOverlay,
    NewsLetterSubscriptionOverlay,
  },
  mixins: [BaseApp],
  data() {
    return {
      show_cookie_layer: false,
      showMobileActionButtons: false,
      successfullyUnsubscribed: false,
      isNewsletterOverlayVisible: false,
    }
  },
  computed: {
    ...mapState('auth', ['settings']),
  },
  created() {
    initGTM(this.$gtm)
    this.showNewsletterOverlay()
  },
  updated() {
    const cdisc = Cookie.get('cdisc')
    this.show_cookie_layer = !(cdisc && cdisc === 'true')
  },
  methods: {
    showNewsletterOverlay() {
      if (this.$route.fullPath.startsWith('/de_DE?unsubscribe=0')) {
        // this.show_cookie_layer = false
        this.isNewsletterOverlayVisible = true
        this.successfullyUnsubscribed = false
      } else if (this.$route.fullPath.startsWith('/de_DE?unsubscribe=1')) {
        this.isNewsletterOverlayVisible = true
        this.successfullyUnsubscribed = true
      } else {
        this.closeNewsletterOverlay()
      }
    },
    closeNewsletterOverlay() {
      this.isNewsletterOverlayVisible = false
    },
  },
}
</script>
